import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import PageSection from '@/components/LandingPages/PageSection/PageSection';
import { classNameMerge } from '@/lib/utils';
import { useState } from 'react';
import CaseStudyCard from './components/CaseStudyCard/CaseStudyCard';
import ComingSoonCard from './components/ComingSoonCard/ComingSoonCard';
import FilterBar from './components/FilterBar/FilterBar';
export default function CaseStudyGrid(_a) {
    var caseStudies = _a.caseStudies, movements = _a.movements, types = _a.types;
    var _b = useState(new Set()), activeMovements = _b[0], setActiveMovements = _b[1];
    var _c = useState(new Set()), activeTypes = _c[0], setActiveTypes = _c[1];
    var toggleMovement = function (value) {
        setActiveMovements(function (prev) {
            var next = new Set(prev);
            if (next.has(value)) {
                next.delete(value);
            }
            else {
                next.add(value);
            }
            return next;
        });
    };
    var toggleType = function (value) {
        setActiveTypes(function (prev) {
            var next = new Set(prev);
            if (next.has(value)) {
                next.delete(value);
            }
            else {
                next.add(value);
            }
            return next;
        });
    };
    var clearAll = function () {
        setActiveMovements(new Set());
        setActiveTypes(new Set());
    };
    var filteredStudies = caseStudies.filter(function (cs) {
        var movementMatch = activeMovements.size === 0 || activeMovements.has(cs.movement);
        var typeMatch = activeTypes.size === 0 || cs.types.some(function (t) { return activeTypes.has(t); });
        return movementMatch && typeMatch;
    });
    return (_jsx(PageSection, { "data-testid": "eo-case-study-grid-section", id: "cs-grid", label: "Case Studies", children: _jsxs("div", { className: "max-w-7xl mx-auto", children: [_jsxs("div", { className: "mb-7", children: [_jsx("p", { className: classNameMerge('inline-flex items-center gap-2 text-[11px] font-bold tracking-[0.1em] uppercase', 'text-secondary mt-[0.625rem]', "before:content-['—'] before:opacity-45 after:content-['—'] after:opacity-45"), children: "The Everyday Organizer" }), _jsx("h2", { className: "font-title text-[30px] font-black tracking-[-0.5px] leading-[1.12] text-foreground", children: "Learn from real campaigns" })] }), _jsx("div", { className: "mb-8", children: _jsx(FilterBar, { activeMovements: activeMovements, activeTypes: activeTypes, movements: movements, onClearAll: clearAll, onToggleMovement: toggleMovement, onToggleType: toggleType, types: types }) }), _jsxs("div", { className: "grid grid-cols-1 mdl:grid-cols-2 gap-[22px]", "data-testid": "eo-cs-grid-cards", id: "cs-grid-cards", children: [filteredStudies.map(function (cs) { return (_jsx(CaseStudyCard, { caseStudy: cs }, cs.slug)); }), _jsx(ComingSoonCard, {})] }), filteredStudies.length === 0 && (_jsxs("div", { "aria-live": "polite", className: "py-12 text-center", "data-testid": "eo-no-results", children: [_jsx("p", { className: "text-base font-bold text-foreground mb-[0.5rem]", children: "No stories match those filters yet" }), _jsxs("p", { className: "text-sm text-muted-foreground", children: ["We're adding new case studies regularly.", ' ', _jsx("a", { className: "text-secondary font-semibold hover:underline", href: "#contact-form", children: "Get in touch" }), ' ', "and we'll let you know when one matches your cause."] })] }))] }) }));
}
